import React from 'react';
import propTypes from 'propTypes';
import Label from 'components/shared/Label';
import { Form, Field, Input, reduxForm, Submit } from 'common/components/Form';
import * as v from 'common/validators';
import * as utils from 'apps/account/utils';

const validate = values => ({
  phone: v.required(values.phone) || v.phoneNumber(values.phone),
});

export class SmsSubscriptionForm extends React.Component {
  static propTypes = {
    onSubmit: propTypes.func.isRequired,
  };

  render() {
    const { handleSubmit, isSubmitting, phone } = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Field
          name="phone"
          type="phone"
          placeholder={'Cell phone number'}
          component={Input}
          label="Phone"
          normalize={utils.formatPhone}
        />
        <Submit
          className="SmsSubscriptionForm__submit Button--primary"
          processing={isSubmitting}
          disabled={isSubmitting}
        >
          sign up
        </Submit>
      </Form>
    );
  }
}

export default reduxForm({
  form: 'sms_subscription_form',
  validate,
})(SmsSubscriptionForm);



// WEBPACK FOOTER //
// ./app/javascript/apps/sms_subscriptions/components/SmsSubscriptionForm.js